import {
  MODAL_EXPORT_PROMPT,
  MODAL_SHARE,
} from '@components/App/Modal/constants'
import { Tab } from '@components/App/Modal/Share/Share'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

export const useExportAsPrompt = (withBack?: boolean) => {
  const dispatch = useDispatch()

  return () => {
    sendGtmEvent(GtmTriggerName.EXPORT_PROMPT)

    dispatch(
      openModal({
        modalType: MODAL_EXPORT_PROMPT,
        modalProps: {
          ...(withBack && {
            onBack: {
              to: MODAL_SHARE,
              params: {
                activeTab: Tab.Export,
              },
            },
          }),
        },
      })
    )
  }
}
